import {connect} from 'react-redux';
import {push} from 'connected-react-router'
import {
    Header, 
    Paragraph, 
    Button,
    NavigationLinkButton
} from '../../components/RegularComponents'
import ReviewForm from '../../components/ReviewForm/ReviewForm'
import TopNavigationBar from "../TopNavigationBar"
import { useState } from 'react';
import { 
    trustAccountSelect,
    populateTrustAccountData
} from '../../redux/selector/trustAccountSelector';
// import { setTrustAccountDetails } from '../../redux/slice/collectionApplicationSlice'
import {
    VIEW_MODE_REGULAR,
    APPLICATION_MODE_RENEW,
    VIEW_MODE_RENEWAL_PREVIEW,
    VIEW_MODE_RENEWAL_EDIT,
    VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT,
} from '../../app/constants'
import { replaceUrlParams } from '../../app/utils';
import Navigation from '../Navigation';
import { extractBase64, fileTypeEnum } from '../../app/documentUploadUtils';

const TrustAccount = (props) => {
    const {trustAccount, dispatch} = props
    const {applicationType, applicationMode} = props.match.params
    const trustAccountViewDetails = (trustAccount[applicationType] ? 
        trustAccount[applicationType] : props.trustAccount)

    let defaultTrustDetails = {
        name : "",
        branchName : "",
        branchAddress : {
            singleLineAddress : ""
        }
    }
    const [trustAccountInstitution, setTrustAccountInstitution] = useState(trustAccount.trustAccountInstitution ? trustAccount.trustAccountInstitution : defaultTrustDetails)
    const [trustAccountLetterFile, setTrustAccountLetterFile] = useState(trustAccount.trustAccountFinancialStatementLetter)
    
    const [viewMode,setViewMode] = useState(props.viewMode ? 
        props.viewMode : (applicationMode === APPLICATION_MODE_RENEW ? 
            VIEW_MODE_RENEWAL_PREVIEW : VIEW_MODE_REGULAR))
    
    const onNextClick = () => {
        // dispatch(setTrustAccountDetails({
        //     trustAccountInstitution,
        //     trustAccountFinancialStatementLetter : trustAccountLetterFile
        // }))
        
        let nextUrl = trustAccountViewDetails.navigation.next
        if((viewMode === VIEW_MODE_RENEWAL_PREVIEW || viewMode === VIEW_MODE_RENEWAL_EDIT)
            && trustAccountViewDetails.navigation.nextRenewal) {
            nextUrl = trustAccountViewDetails.navigation.nextRenewal
        }
        dispatch(push(replaceUrlParams(nextUrl,applicationType, applicationMode)))
    }
    const trustDetailsForm = () => {
        return (
            <fieldset className="ns-fieldset">
                <div className="ns-fieldset">
                    {/* account name */}
                    <label 
                        id="trust-name-input-label"
                        className="ns-label"
                        htmlFor="trust-name-input">
                            Name of financial institution
                    </label>
                    <input 
                        id="trust-name-input"
                        name="trust-name-input"
                        className="ns-input fw-20"
                        type="text"
                        value={trustAccountInstitution.name}
                        onChange = {(e) => {
                            setTrustAccountInstitution(Object.assign({}, 
                                trustAccountInstitution, {name : e.target.value}))
                        }}
                    />
                </div>
                <div className="ns-fieldset">
                    {/* branch */}
                    <label 
                        id="trust-branch-input-label"
                        className="ns-label"
                        htmlFor="trust-branch-input">
                            Branch name
                    </label>
                    <input 
                        id="trust-branch-input"
                        name="trust-branch-input"
                        className="ns-input fw-20"
                        type="text"
                        value={trustAccountInstitution.branchName}
                        onChange = {(e) => {
                            setTrustAccountInstitution(Object.assign({}, 
                                trustAccountInstitution, {branchName : e.target.value}))
                        }}
                    />
                </div>
                <div className="ns-fieldset">
                    {/* branch address */}
                    <label 
                        id="trust-branch-address-input-label"
                        htmlFor="trust-branch-address-input">
                            Branch address
                    </label>
                    <input 
                        id="trust-branch-address-input"
                        name="trust-branch-address-input"
                        type="text"
                        className="ns-input fw-25"
                        value={trustAccountInstitution.address && trustAccountInstitution.address.singleLineAddress ? trustAccountInstitution.address.singleLineAddress : ""}
                        onChange = {(e) => {
                            setTrustAccountInstitution(Object.assign({}, 
                                trustAccountInstitution, 
                                {address : {singleLineAddress : e.target.value}}))
                        }}
                    />
                </div>
            </fieldset>
        )
    }

    const onFileInputChange = (e) => {
        if(e.target.files.length > 0) {
            let file = e.target.files[0]
            
            let reader = new FileReader()
            reader.onload = (readerData) => {
                setTrustAccountLetterFile({
                    filename : file.name, 
                    documentContentType : fileTypeEnum(file.type),
                    data : extractBase64(readerData.target.result),
                    changeType : "SAVE",
                    businessLicencingSubType: "COLLECTION_AGENCY_APPLICATION",
                    documentType: "FINANCIAL_STATEMENT_LETTER",
                })
            }
            reader.readAsDataURL(file)
        }
    }

    const trustStatementInputForm = () => {
        return (
            <div>
                <label 
                    id="trust-financial-letter-file-label"
                    htmlFor="trust-financial-letter-file-input">
                        Upload a recent financial statement or letter from your bank.
                </label>
                <input 
                    type="file" 
                    id="trust-financial-letter-file-input" 
                    name="trust-financial-letter-file-input"
                    multiple={false} 
                    value=""
                    onInput={onFileInputChange} />
            </div>
        )
    }

    return (
        <>
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT &&
            <Navigation {...props} />}
            <div className={viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT ? "container" : ""}>
                {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT &&
                <>
                    <TopNavigationBar {...props} />
                    <div className="row">
                        <div className="col-lg-8">
                            <Header 
                                id="trust-account-details-header"
                                header={viewMode === VIEW_MODE_RENEWAL_PREVIEW ?
                                    trustAccountViewDetails.headerRenewal : trustAccountViewDetails.header} />
                            <Paragraph
                                id="trust-account-details-text"
                                text={viewMode === VIEW_MODE_RENEWAL_PREVIEW ?
                                    trustAccountViewDetails.textRenewal : trustAccountViewDetails.text} />
                        </div>
                    </div>
                    </>
                }
                <div className="row bottomMarginNormal">
                    <div className="col-lg-12">
                        {viewMode === VIEW_MODE_RENEWAL_PREVIEW &&
                            <ReviewForm data={populateTrustAccountData(trustAccountInstitution, trustAccountLetterFile)} />
                        }
                        {viewMode !== VIEW_MODE_RENEWAL_PREVIEW && 
                            trustDetailsForm()
                        }
                    </div>
                </div>
                {viewMode !== VIEW_MODE_RENEWAL_PREVIEW &&
                    <>
                        {trustAccountLetterFile.filename && 
                            <div className="bottomMarginNormal"> 
                                {trustAccountLetterFile.filename}
                            </div>
                        }
                        <div className="bottomMarginLarge">
                            {trustStatementInputForm()}
                        </div>
                    </>
                }
                {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT &&
                <>
                    <div className="row bottomMarginMedium">
                        <div className="col-lg-4">
                            <Button 
                                id="trust-account-save-next-button"
                                text={"Save and next"}
                                buttonType={"regular_primary"}
                                onClick={onNextClick}
                            />
                        </div>
                        {viewMode === VIEW_MODE_RENEWAL_PREVIEW && 
                        <div className="col-lg-4">
                            <NavigationLinkButton 
                                id={"trust-account-edit-mode-switch"}
                                text={"Update this information before continuing"}
                                onClick={() => { setViewMode(VIEW_MODE_RENEWAL_EDIT)}}
                            />
                        </div>}
                    </div>
                </>
                }
                {viewMode === VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT &&
                <>
                    <div className="row bottomMarginNormal">
                        <Button 
                            text="Save"
                            id="trust-account-save-button"
                            buttonType="regular_primary"
                            onClick={() => {
                                // props.dispatch(setTrustAccountDetails({
                                //     trustAccountInstitution,
                                //     trustAccountFinancialStatementLetter : trustAccountLetterFile
                                // }))
                                props.onEditSave()
                            }}
                        />
                    </div>
                </>
                }
            </div>
        </>
    )
}

export default connect(trustAccountSelect)(TrustAccount)
